// extracted by mini-css-extract-plugin
var _1 = "errorBox--KrttL";
var _2 = "errorBullet--zDMRz";
var _3 = "errorItem--ZFG8U";
var _4 = "errorText--Ocr3C";
export { _1 as "errorBox", _2 as "errorBullet", _3 as "errorItem", _4 as "errorText" }
